<template>
  <div class="customer-read-guarantors">
    <former-box
      title="Avalistas"
      subtitle="Listagem de avalistas"
      collapsable
      :start-collapsed="!guarantors.length"
    >
      <state-messages
        key="customer-read-guarantors-state"
        class="customer-read-guarantors-state"
        :state="guarantorsState"
        :iconed="false"
      >
        <template v-slot:empty>
          Nenhum avalista cadastrado
        </template>
      </state-messages>

      <template v-if="guarantors.length">
        <customer-list-item
          v-for="guarantor in guarantors"
          :key="guarantor.id"
          class="customer-read-gurantors-item"
          :customer="guarantor"
          :label="guarantor.name"
          :loading="guarantorLoading"
          guarantor
          @destroy="destroy"
        />
      </template>

      <div class="customer-read-guarantors-actions">
        <former-button
          size="small"
          @click="newGuarantor"
        >
          Adicionar avalista
        </former-button>
      </div>
    </former-box>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import StateMessages from '@/components/State/Messages.vue';

  import CustomerListItem from '@/components/Customers/List/Item.vue';

  import FormerBox from '@/components/Former/Box.vue';
  import FormerButton from '@/components/Former/Button.vue';

  export default {
    name: 'CustomerReadInformationsGuarantors',
    components: {
      FormerButton,
      FormerBox,
      StateMessages,
      CustomerListItem,
    },
    props: {
      guarantors: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapState([
        'customers',
        'customersGuarantors',
      ]),

      customer() {
        return this.customers.read.item;
      },

      guarantorsState() {
        return this.guarantors.length ? 'ready' : 'empty';
      },
      guarantorLoading() {
        return this.customersGuarantors.delete.loading;
      },
    },
    methods: {
       newGuarantor() {
        this.$router.push({
          name: 'customers-new',
          query: {
            customer_id: this.customer.id,
            guarantor: true,
          },
        });
      },

      destroy(id) {
        this.$store
          .dispatch('customersGuarantors/delete', {
            id: this.customer.id,
            delete: id,
          })
          .then(this.destroySuccess);
      },
      destroySuccess() {
        this.$store.dispatch('customers/read', {
          id: this.customer.id,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .customer-read-guarantors {
    border-bottom: $spacing solid $gray-light;
  }

  .customer-read-gurantors-item {
    background-color: $gray-light;
    border-radius: $button * 0.5;
    margin: 0 (-$gutter-small);
    padding: $gutter;

    & + & {
      margin-top: $gutter-small;
    }

    & > a {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &:hover {
      background-color: $blue-light;
    }

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter + $gutter-smaller $gutter-big;
    }
  }

  .customer-read-guarantors-actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: $gutter (-$gutter-small) 0;
    text-align: right;
  }

  .customer-read-guarantors-state {
    padding: 0;
  }
</style>
